export default __webpack_public_path__ + "static/media/whiteUpArrow.aad52651.svg";